module.exports = __webpack_public_path__ + "static/p-mw-c52632c4c91029e4b2879cfda0750b44.jpg";